<template>
  <div class="townhall">
    <div class="townhall__image" @click="goToUpgrades"></div>
    <transition-group name="goldlist" @enter="goldEnter">
      <div
        class="townhall__incoming townhall__incoming--gold"
        v-for="gold in goldList"
        :key="'gold' + gold.time"
      >{{ gold.diff }}</div>
    </transition-group>

    <transition-group name="woodlist" @enter="woodEnter">
      <div
        class="townhall__incoming townhall__incoming--wood"
        v-for="wood in woodList"
        :key="'wood' + wood.time"
      >{{ wood.diff }}</div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "TownHall",
  data() {
    return {
      goldList: [],
      woodList: []
    };
  },
  computed: {
    gold() {
      return this.$store.state.gold;
    },
    wood() {
      return this.$store.state.wood;
    }
  },
  watch: {
    gold(newVal, beforeVal) {
      let diff = newVal - beforeVal;
      this.goldList.push({
        diff,
        time: new Date().getTime()
      });
    },
    wood(newVal, beforeVal) {
      let diff = newVal - beforeVal;
      this.woodList.push({
        diff,
        time: new Date().getTime()
      });
    }
  },
  methods: {
    goldEnter(el, done) {
      gsap.to(el, {
        x: -100 + Math.floor(Math.random() * 100),
        y: -100 + Math.floor(Math.random() * 100),
        opacity: 0,
        duration: 1.5,
        onComplete: () => {
          this.goldList.shift();
        }
      });

      done();
    },
    woodEnter(el, done) {
      gsap.to(el, {
        x: Math.floor(Math.random() * 100),
        y: -100 + Math.floor(Math.random() * 100),
        opacity: 0,
        duration: 1.5,
        onComplete: () => {
          this.woodList.shift();
        }
      });

      done();
    },
    goToUpgrades() {
      this.$router.push("townhall");
    }
  }
};
</script>

<style lang="scss" scoped>
.townhall {
  height: 100%;
  position: relative;
  z-index: 1;

  &__image {
    width: 100%;
    height: 100%;
    cursor: pointer;
    background: url("../../assets/images/townhall.png") center center no-repeat;
    background-size: contain;
  }

  &__incoming {
    position: absolute;
    top: 1rem;
    left: 25%;
    color: theme("colors.yellow.300");

    &:after {
      content: "";
      position: absolute;
      width: 14px;
      height: 14px;
    }

    &--gold {
      &:after {
        background: url("../../assets/images/gold_icon.png");
      }
    }

    &--wood {
      &:after {
        background: url("../../assets/images/wood_icon.png");
      }
    }
  }
}
</style>